"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function IEventFromJSON(json) {
    return IEventFromJSONTyped(json, false);
}
exports.IEventFromJSON = IEventFromJSON;
function IEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'belongsToSeries': !runtime_1.exists(json, 'belongsToSeries') ? undefined : _1.OccurrenceFromJSON(json['belongsToSeries']),
        'headCountsExpected': !runtime_1.exists(json, 'headCountsExpected') ? undefined : json['headCountsExpected'],
        'headCountsActual': !runtime_1.exists(json, 'headCountsActual') ? undefined : json['headCountsActual'],
        'isCancelled': !runtime_1.exists(json, 'isCancelled') ? undefined : json['isCancelled'],
        'feedbackNoteEntityId': !runtime_1.exists(json, 'feedbackNoteEntityId') ? undefined : json['feedbackNoteEntityId'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'start': !runtime_1.exists(json, 'start') ? undefined : (new Date(json['start'])),
        'minutesDuration': !runtime_1.exists(json, 'minutesDuration') ? undefined : json['minutesDuration'],
        'organizerPersonEntityId': !runtime_1.exists(json, 'organizerPersonEntityId') ? undefined : json['organizerPersonEntityId'],
        'address': !runtime_1.exists(json, 'address') ? undefined : _1.AddressFromJSON(json['address']),
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'url': !runtime_1.exists(json, 'url') ? undefined : json['url'],
        'registrationOnly': !runtime_1.exists(json, 'registrationOnly') ? undefined : json['registrationOnly'],
        'entityId': !runtime_1.exists(json, 'entityId') ? undefined : json['entityId'],
        'properties': !runtime_1.exists(json, 'properties') ? undefined : json['properties'],
        'integration': !runtime_1.exists(json, 'integration') ? undefined : _1.IntegrationFromJSON(json['integration']),
        'belongsTo': !runtime_1.exists(json, 'belongsTo') ? undefined : json['belongsTo'],
        'limit': !runtime_1.exists(json, 'limit') ? undefined : _1.LimitFromJSON(json['limit']),
        'registrationOpen': !runtime_1.exists(json, 'registrationOpen') ? undefined : (json['registrationOpen'] === null ? null : new Date(json['registrationOpen'])),
        'registrationOpenDaysBefore': !runtime_1.exists(json, 'registrationOpenDaysBefore') ? undefined : json['registrationOpenDaysBefore'],
        'registrationClose': !runtime_1.exists(json, 'registrationClose') ? undefined : (json['registrationClose'] === null ? null : new Date(json['registrationClose'])),
        'registrationCloseDaysBefore': !runtime_1.exists(json, 'registrationCloseDaysBefore') ? undefined : json['registrationCloseDaysBefore'],
        'checkInOpen': !runtime_1.exists(json, 'checkInOpen') ? undefined : (json['checkInOpen'] === null ? null : new Date(json['checkInOpen'])),
        'checkInOpenHoursBefore': !runtime_1.exists(json, 'checkInOpenHoursBefore') ? undefined : json['checkInOpenHoursBefore'],
        'checkInClose': !runtime_1.exists(json, 'checkInClose') ? undefined : (json['checkInClose'] === null ? null : new Date(json['checkInClose'])),
        'checkInCloseHoursAfter': !runtime_1.exists(json, 'checkInCloseHoursAfter') ? undefined : json['checkInCloseHoursAfter'],
        'uniqueCode': !runtime_1.exists(json, 'uniqueCode') ? undefined : json['uniqueCode'],
    };
}
exports.IEventFromJSONTyped = IEventFromJSONTyped;
function IEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'belongsToSeries': _1.OccurrenceToJSON(value.belongsToSeries),
        'type': value.type,
        'address': _1.AddressToJSON(value.address),
        'description': value.description,
        'url': value.url,
        'properties': value.properties,
        'integration': _1.IntegrationToJSON(value.integration),
        'limit': _1.LimitToJSON(value.limit),
    };
}
exports.IEventToJSON = IEventToJSON;
